import { Box, Skeleton } from '@mui/material';
import MutableDataTable from './MutableDataTable';
import { MutableDataTableProps } from './types';

type Props = MutableDataTableProps & {
  isLoading: boolean;
};

const MutableDataTableLoading = ({ isLoading, ...props }: Props) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <Skeleton variant="text" width="100%" height="32px" />
        <Skeleton variant="text" width="100%" height="24px" />
        <Skeleton variant="text" width="100%" height="24px" />
      </Box>
    );
  }

  return <MutableDataTable {...props} />;
};

export default MutableDataTableLoading;
